export default {"src":"/_next/static/media/no_data_available.1f304c25.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};